import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-play" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

import { DialogHandler } from '../../dialog/DialogHandler';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExecuteButton',
  setup(__props) {

const onExecute = () => DialogHandler.showSaveDialog();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "mx-1 btn btn-outline-dark",
    "data-placement": "top",
    alt: "実行",
    onClick: onExecute
  }, _hoisted_2))
}
}

})